// extracted by mini-css-extract-plugin
module.exports = {"blocked":"w_d","loader":"w_f","post":"w_bM"};